import React from 'react';
import { InView } from 'react-intersection-observer';
import { TopProductIds } from './types';
import ProductHeader from './product-header';
import { ProductPageQuery } from '../../../../types';
import { getHeaderHeight } from '../../utils';

const ProductPageHeader: React.FC<IProductPageHeaderProps> = props => {
  const {
    product,
    isMobile,
    setHeaderVisible,
    isHeaderVisible,
    currentCampaign,
  } = props;

  if (!product) {
    return null;
  }

  const onHeaderVisibilityChange = (isVisible: boolean) => {
    if (isHeaderVisible !== isVisible) {
      setHeaderVisible(isVisible);
    }
  };

  return (
    <InView
      onChange={onHeaderVisibilityChange}
      rootMargin={`-${getHeaderHeight(isMobile) - 10}px`}
    >
      <ProductHeader
        title={product.name}
        product={product}
        currentCampaign={currentCampaign}
        categoryTopProducts={getCategoryTopProducts(product)}
      />
    </InView>
  );
};

const getCategoryTopProducts = (
  product: ProductPageQuery['product']
): TopProductIds | null => {
  if (!product?.category?.products?.nodes.length) return null;

  // Returns array with current product id + top 10 product ids in same category.
  const topTenIds = product.category.products.nodes
    .filter(node => node?.id !== product.id)
    .map(node => {
      return { id: node!.id };
    });

  return [{ id: product.id }, ...topTenIds];
};

interface IProductPageHeaderProps {
  product: ProductPageQuery['product'];
  isMobile: boolean | undefined;
  isHeaderVisible: boolean;
  setHeaderVisible: React.Dispatch<React.SetStateAction<boolean>>;
  currentCampaign: any;
}

export default ProductPageHeader;
